/**
 * useWebSocket Hook
 * 
 * React hook for WebSocket connection management
 */

import { useEffect, useState } from 'react';
import { wsClient, WSConnectionState } from '@/lib/ws';
import { logger } from '@/lib/logger';

export function useWebSocket() {
  const [connectionState, setConnectionState] = useState<WSConnectionState>('disconnected');
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // DISABLED: Socket.IO client incompatible with native WebSocket backend
    // TODO: Replace Socket.IO client with native WebSocket
    // wsClient.connect();

    logger.warn('[useWebSocket] WebSocket disabled (Socket.IO vs native WS incompatibility)');

    // Setup handlers (but don't connect)
    const unsubscribeConnect = wsClient.onConnect(() => {
      setConnectionState('connected');
      setIsConnected(true);
      logger.info('[useWebSocket] Connected');
    });

    const unsubscribeDisconnect = wsClient.onDisconnect(() => {
      setConnectionState('disconnected');
      setIsConnected(false);
      logger.warn('[useWebSocket] Disconnected');
    });

    const unsubscribeError = wsClient.onError((error) => {
      logger.error('[useWebSocket] Error', error);
    });

    // Update initial state
    setConnectionState('disconnected');
    setIsConnected(false);

    // Cleanup on unmount
    return () => {
      unsubscribeConnect();
      unsubscribeDisconnect();
      unsubscribeError();
      // Don't disconnect here - keep connection alive for the app
    };
  }, []);

  return {
    connectionState,
    isConnected,
    connect: () => wsClient.connect(),
    disconnect: () => wsClient.disconnect(),
  };
}








